import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

export const useMediaItemChildOptionsApi = (mediaItemId: string) => {
  const { data, ...rest } = useQuery({
    ...MediaPlan.getMediaItemChildOptionsQueryOptions({
      urlParams: { mediaItemId },
    }),
    refetchOnWindowFocus: false,
  });

  return {
    data: data?.data?.items[0],
    ...rest,
  };
};
